import React, { useState, useEffect } from "react"
import { useNavigate } from "react-router-dom"


async function sendToDiscord() {
    await fetch('https://hook.us1.make.com/nr67atygpmrsxkekxgv0x6jpncfx7iop', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            content: 'HELLO WORLD',
        }),
    });
}



function Gabe() {

    return (
        <>
        <p>TEST PAGE</p>
        <button onClick={() => sendToDiscord()}>SEND TO DISCORD</button> 
        </>
    )

}

export default Gabe
